module.exports = __webpack_public_path__ + "static/media/clouds-tp-filled.dffd4408.png";